import Vue from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-grid.css';
import 'bootstrap/dist/css/bootstrap-reboot.css';

import 'bootstrap';

import {CHECK_LOGIN_ACTION} from "@/store/actions";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  async mounted() {
    await store.dispatch(CHECK_LOGIN_ACTION);
  }
}).$mount('#app');
